import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, PackageIcon, PaletteIcon, VolumeXIcon } from 'lucide-react';
import { ClockPreview } from '../components/ClockPreview';
import { heroPhoto, themes } from '../data/themes';
const etapes = [{
  titre: 'Choisissez votre visuel',
  texte: 'Une cinquantaine de décors d’atelier — animaux, paysages, fleurs — ou votre propre photo importée en un clic.'
}, {
  titre: 'Ajoutez votre texte',
  texte: 'Un prénom, une date, une dédicace : deux lignes gravées dans le décor, visibles en direct sur l’aperçu.'
}, {
  titre: 'Validez le bon à tirer',
  texte: 'Nous vous envoyons le visuel final sous 24 h. Impression et assemblage à la main dès votre accord.'
}];
export function Home() {
  return <main data-id="element-160" data-mp="3kw1z78zul1a7">
      <section className="border-b border-line bg-cream" data-id="element-161" data-mp="3ku8rrrheud15">
        <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-16 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:py-24" data-id="element-162" data-mp="3owvni3h7ci3m">
          <div data-id="element-163" data-mp="30x1hgaoqwgoe">
            <p className="text-xs uppercase tracking-[0.22em] text-terracotta" data-id="element-164" data-mp="30vqay33x0utl">
              Atelier français · Pièce unique
            </p>
            <h1 className="mt-5 font-display text-4xl leading-[1.08] text-ink sm:text-5xl lg:text-6xl" data-id="element-165" data-mp="2vvvms7biyjc8">
              L’horloge qu’on offre
              <span className="block italic text-forest" data-id="element-166" data-mp="2mxs1nc4gboky">et qu’on n’oublie pas.</span>
            </h1>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-muted" data-id="element-167" data-mp="2hy6zkstzj040">
              Choisissez un décor, importez votre photo, ajoutez le prénom de la personne : votre
              horloge se dessine en direct devant vous. Fabriquée et assemblée à Saumur.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-168" data-mp="239at307ktv5i">
              <Link to="/personnaliser" className="inline-flex items-center gap-2 rounded-full bg-forest px-7 py-3.5 text-sm font-medium text-cream transition-colors duration-150 ease-out hover:bg-forest-dark" data-id="element-169" data-mp="2376ijzf69xw9">
                Personnaliser mon horloge
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-170" data-mp="1kn3falg0e559" />
              </Link>
              <Link to="/modeles" className="text-sm text-muted underline underline-offset-4 transition-colors duration-150 ease-out hover:text-ink" data-id="element-171" data-mp="1ok7u8dbm3jlr">
                Voir les modèles
              </Link>
            </div>
            <p className="mt-8 text-sm text-muted" data-id="element-172" data-mp="23cje94c1ppjk">
              À partir de <span className="font-medium text-ink" data-id="element-173" data-mp="28atbrll8t28c">39 €</span> · Mécanisme silencieux ·
              Expédition en 3 jours
            </p>
          </div>

          <div className="mx-auto w-full max-w-md" data-id="element-174" data-mp="1tl5d6s4g4hob">
            <ClockPreview image={themes[0].image} numerals="aucun" hands="noir" frame="aucun" texte="" sousTexte="" mecanisme="silencieux" label="Horloge personnalisée sur le thème des chevaux" data-id="element-175" data-mp="1yjqc8o7yovb6" />
          </div>
        </div>
      </section>

      <section aria-labelledby="etapes-titre" className="mx-auto max-w-6xl px-5 py-20" data-id="element-176" data-mp="fjhc43srapu7">
        <h2 id="etapes-titre" className="font-display text-3xl text-ink" data-id="element-177" data-mp="akmu342m55b5">
          Trois étapes, dix minutes
        </h2>
        <ol className="mt-10 space-y-8" data-id="element-178" data-mp="kcski9d7veo8">
          {etapes.map((etape, index) => <li key={etape.titre} className="grid gap-4 sm:grid-cols-[auto_1fr] sm:gap-8" data-id="element-179" data-mp="kewpkumuqjq3" data-mpi={index}>
              <div className="flex items-center gap-4 sm:block" data-id="element-180" data-mp="3su6x4i9igh59">
                <span className="font-display text-4xl text-terracotta/80 tabular-nums" data-id="element-181" data-mp="3nukgdyuh4irp">
                  0{index + 1}
                </span>
              </div>
              <div className="border-t border-line pt-4 sm:pt-5" data-id="element-182" data-mp="o1p2iqlfu7b">
                <h3 className="font-display text-xl text-ink" data-id="element-183" data-mp="qnsq7ad5pk9">{etape.titre}</h3>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted" data-id="element-184" data-mp="1h0yjogrddev4">{etape.texte}</p>
              </div>
            </li>)}
        </ol>
      </section>

      <section aria-labelledby="modeles-titre" className="border-y border-line bg-parchment" data-id="element-185" data-mp="27ey75p657luw">
        <div className="mx-auto max-w-6xl px-5 py-20" data-id="element-186" data-mp="2ce12uj08gfq7">
          <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-187" data-mp="2cesxnrm0a9ff">
            <h2 id="modeles-titre" className="font-display text-3xl text-ink" data-id="element-188" data-mp="2harjb7fy9dc5">
              Les décors les plus offerts
            </h2>
            <Link to="/modeles" className="text-sm text-muted underline underline-offset-4 hover:text-ink" data-id="element-189" data-mp="2qd0qbnc0eoks">
              Tous les modèles
            </Link>
          </div>

          <ul className="mt-10 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:grid-cols-5" data-id="element-190" data-mp="3020vjoh3ug7f">
            {themes.map(theme => <li key={theme.id} data-id="element-191" data-mp="35140l8x34mfe">
                <Link to={`/personnaliser?theme=${theme.id}`} className="group block" data-id="element-192" data-mp="3a0qd1g539yn5">
                  <img src={theme.image} alt={theme.nom} className="aspect-square w-full scale-105 rounded-full object-cover transition-transform duration-200 ease-out group-hover:scale-110" data-id="element-193" data-mp="39yx2hprcuu9v" />
                  <h3 className="mt-4 font-display text-base text-ink" data-id="element-194" data-mp="ybtm6kmd8bl8">{theme.nom}</h3>
                  <p className="mt-1 text-xs leading-snug text-muted" data-id="element-195" data-mp="tf34xtytr9y8">{theme.categorie}</p>
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-20 lg:grid-cols-2 lg:gap-16" data-id="element-196" data-mp="1m1xnglc2zz92">
        <img src={heroPhoto} alt="Horloge personnalisée accrochée au-dessus d’un buffet en chêne" className="w-full rounded-2xl object-cover shadow-card" data-id="element-197" data-mp="1h578y2fxdbpr" />
        <div data-id="element-198" data-mp="17d1kh2ovtcfb">
          <h2 className="font-display text-3xl leading-tight text-ink" data-id="element-199" data-mp="17djo4kdvisx9">
            Un objet du quotidien, fabriqué comme un cadeau
          </h2>
          <dl className="mt-8 space-y-7" data-id="element-200" data-mp="202qid76aowcp">
            <div className="flex gap-4" data-id="element-201" data-mp="201yoq1w9d8p2">
              <PaletteIcon className="mt-1 h-5 w-5 shrink-0 text-forest" aria-hidden="true" data-id="element-202" data-mp="200xbprvomc4p" />
              <div data-id="element-203" data-mp="3ucyfufe3huhc">
                <dt className="text-sm font-medium text-ink" data-id="element-204" data-mp="26ju9rrbksul">Impression haute définition</dt>
                <dd className="mt-1 text-sm leading-relaxed text-muted" data-id="element-205" data-mp="3kkspfa3hrl49">
                  Encres UV sur support rigide 5 mm, couleurs stables dans le temps et finition
                  satinée anti-reflets.
                </dd>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-206" data-mp="3ala9d4qpcjhh">
              <VolumeXIcon className="mt-1 h-5 w-5 shrink-0 text-forest" aria-hidden="true" data-id="element-207" data-mp="3flg6v1jnl07h" />
              <div data-id="element-208" data-mp="31m6n5rw8nnyr">
                <dt className="text-sm font-medium text-ink" data-id="element-209" data-mp="31moupkocpolz">Mécanisme vraiment silencieux</dt>
                <dd className="mt-1 text-sm leading-relaxed text-muted" data-id="element-210" data-mp="36k868ctnzna8">
                  Mouvement à balayage continu, sans tic-tac. Une pile AA, trois ans d’autonomie.
                </dd>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-211" data-mp="14sbtizvrg7dv">
              <PackageIcon className="mt-1 h-5 w-5 shrink-0 text-forest" aria-hidden="true" data-id="element-212" data-mp="1exl9wchlvhrd" />
              <div data-id="element-213" data-mp="1ev7e21f3q1ir">
                <dt className="text-sm font-medium text-ink" data-id="element-214" data-mp="19yqp5502vj4m">Prêt à offrir</dt>
                <dd className="mt-1 text-sm leading-relaxed text-muted" data-id="element-215" data-mp="19wnv89vt15um">
                  Livrée dans un coffret kraft avec carte manuscrite si vous le souhaitez, aiguilles
                  protégées pour le transport.
                </dd>
              </div>
            </div>
          </dl>
        </div>
      </section>

      <section className="bg-forest" data-id="element-216" data-mp="1sphy45g5l7ih">
        <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-5 py-16 sm:flex-row sm:items-center sm:justify-between" data-id="element-217" data-mp="1sogm9yrbcgzp">
          <div data-id="element-218" data-mp="26meyaxi5w1c1">
            <h2 className="font-display text-2xl text-cream sm:text-3xl" data-id="element-219" data-mp="22nflyru3p2ak">
              Votre horloge vous attend sur le configurateur
            </h2>
            <p className="mt-2 text-sm text-cream/70" data-id="element-220" data-mp="cb8ibzpz8r39">
              Aucun engagement : composez, comparez, commandez quand vous êtes prêt.
            </p>
          </div>
          <Link to="/personnaliser" className="inline-flex shrink-0 items-center gap-2 rounded-full bg-cream px-7 py-3.5 text-sm font-medium text-forest-dark transition-colors duration-150 ease-out hover:bg-white" data-id="element-221" data-mp="wt0dkjb1qlqw">
            Commencer
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="1al861yvarqjs" />
          </Link>
        </div>
      </section>
    </main>;
}